module.exports = __webpack_public_path__ + "img/7.ba37f721.svg";